import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/internal/Observable';

import { MaterialAction } from '@app/models';

export interface MaterialActionApi {
  items: MaterialAction[];
  total_count: number;
}

@Injectable({
  providedIn: 'root'
})
export class MaterialActionService {
  private _materialActionsRoute = '/api/material-actions/';

  private headerOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  constructor(private httpClient: HttpClient) { }


  getActions(): Observable<MaterialAction[]> {
    return this.httpClient.get<MaterialAction[]>(this._materialActionsRoute);
  }


  getAction(visitorId: string): Observable<MaterialAction> {
    return this.httpClient.get<MaterialAction>(this._materialActionsRoute + 'visitor/' + visitorId);
  }


  get(_id: any): Observable<MaterialAction> {
    return this.httpClient.get<MaterialAction>(this._materialActionsRoute + _id);
  }


  getByVisitorId(visitorId: string): Observable<MaterialAction[]> {
    return this.httpClient.get<MaterialAction[]>(this._materialActionsRoute + 'visitor/' + visitorId);
  }


  getByOwnerId(ownerId: string): Observable<MaterialAction[]> {
    return this.httpClient.get<MaterialAction[]>(this._materialActionsRoute + 'owner/' + ownerId);
  }


  getByMaterialId(materialId: string): Observable<MaterialAction> {
    return this.httpClient.get<MaterialAction>(this._materialActionsRoute + 'material/' + materialId);
  }


  getByActionType(actionType: string): Observable<MaterialAction[]> {
    return this.httpClient.get<MaterialAction[]>(this._materialActionsRoute + 'actionType/' + actionType);
  }


  search(searchTerms): Observable<MaterialAction[]> {
    return this.httpClient.post<MaterialAction[]>(this._materialActionsRoute + 'search', JSON.stringify(searchTerms), this.headerOptions);
  }


  searchActions(searchParams: MaterialAction): Observable<MaterialAction[]> {
    return this.httpClient.post<any>(this._materialActionsRoute + 'dataSourceSearch', JSON.stringify(searchParams), this.headerOptions);
  }


  // Returns a count.
  checkForUserActions(searchParams: any): Observable<any> {
    return this.httpClient.post<any>(this._materialActionsRoute + 'matchingActions', JSON.stringify(searchParams), this.headerOptions);
  }


  fetchMaterialActionStats(_searchTerms: any, _materialTerms: any = null): Observable<any> {
    const searchData = { actionSearch: _searchTerms ?? {}, materialSearch: _materialTerms ?? {} };
    return this.httpClient.post<any>(this._materialActionsRoute + 'fetchMaterialActionStats', JSON.stringify(searchData), this.headerOptions);
  }


  save(_action: MaterialAction): Observable<MaterialAction> {
    return this.httpClient.post<MaterialAction>(this._materialActionsRoute, JSON.stringify(_action), this.headerOptions);
  }


  createMultiple(_actions: any): Observable<any> {
    return this.httpClient.post<any>(this._materialActionsRoute + 'multiple', JSON.stringify(_actions), this.headerOptions);
  }


  delete(_action: MaterialAction): Observable<any> {
    return this.httpClient.put(this._materialActionsRoute + _action._id, this.headerOptions);
  }
}